export class StateMasterResponseModel{
      appStateMasterId :number;
      appStateName:string;
      appStateCode:string;
      isActive :boolean;
}
